import { Container, Box, Text, get, Heading } from "theme-ui";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

import { AccordionTabs } from "src/components";
import { viewVariants } from "src/utils";

export const Answers: React.FC = () => {

  const { t } = useTranslation();

  return (
    <motion.div
      variants={viewVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <Container
        as="main"
        sx={{
          p: 4,
          maxWidth: (theme) => get(theme, "breakpoints.1"),
        }}
      >
        <Box
          sx={{
            textAlign: "center",
            px: [0, 4, 8],
            mb: [4, 5, 6],
            mt: [5, 6, 7],
          }}
        >
          <Heading
            as="h1"
            sx={{
              fontSize: [5, 5, 7],
              fontWeight: 800,
              display: "block",
              mb: [3, 3, 4],
            }}
          >
            {t("faq.title")}
          </Heading>
          <Text as="p" sx={{ fontSize: [2, 2, 3] }}>
            {t("faq.text")}
          </Text>
        </Box>
        <AccordionTabs />
      </Container>
    </motion.div>
  );
};
